import { Grid, Pagination } from '@mui/material';
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import swal from 'sweetalert';
import { Encabezado } from '../../Components/Encabezado/Encabezado';
import { VotacionCriteriosCard } from '../../Components/Encuesta/Modals/VotacionCriteriosCard';
import { VotarCard } from '../../Components/Encuesta/VotarCard';
import Loading from '../../Components/Modals/Loading/Loader';
import {
  fetchBuscarEncuestas,
  fetchCambiarSuccess,
  fetchVerificarVoto,
  selectEncuestas,
  selectHaVotado,
  selectIsLoading,
  selectIsSuccess,
  selectMessage,
  selectVoto,
} from '../../redux/Encuestas/EncuestasSlice';
import { selectUserData } from '../../redux/Login/LoginSlice';

import { removeAccents } from '../../utils/removeAccents';

export const EncuestasVotar = () => {
  // ? HOOK-LOCATION
  const location = useLocation();
  const encuesta = location.state;

  // ? HOOK-FORM
  const form = useForm({
    defaultValues: {
      criteriosEmpleado: [],
    },
  });

  // * DESESTRUCTURACION DEL FORM.
  const { setValue, reset } = form;

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? Selectors
  const usuario = useSelector(selectUserData);
  const usuarioVotado = useSelector(selectVoto);
  const haVotado = useSelector(selectHaVotado);
  const isLoading = useSelector(selectIsLoading);
  const isSuccess = useSelector(selectIsSuccess);
  const message = useSelector(selectMessage);
  const encuestas = useSelector(selectEncuestas);

  // ? HOOK-STATE
  const [page, setPage] = useState(1);
  const [countParticipantesFilter, setCountParticipantesFilter] = useState(0);
  const [openVotacionCriterios, setOpenVotacionCriterios] = useState({ open: false, empleado: {} });
  const [participanteNombre, setParticipanteNombre] = useState('');
  const [participantesPagina, setParticipantesPagina] = useState([]);

  // * DESESTRUCTURACION DE DATOS.
  const { titulo, participantes = [], criteriosHabilitado, criterios = [] } = encuestas?.find((x) => x.encuestaId === encuesta.encuestaId) ?? {};

  useEffect(async () => {
    if (!usuarioVotado || Object.keys(usuarioVotado).length === 0) {
      const voto = {
        encuestaId: encuesta.encuestaId,
        empleadoId: usuario.Id,
      };
      dispatch(fetchVerificarVoto(voto));
    }
  }, []);

  // * CANTIDAD DE CARTAS POR PAGINA.
  const cardsPorPagina = 25;

  // * Función para filtrar participantes
  const filtrarParticipantes = (participantes, busqueda) => {
    // Si no hay búsqueda, simplemente retorna todos los participantes
    if (!busqueda) {
      return participantes;
    }

    // Normaliza la búsqueda (elimina acentos) y pasa todo a minúsculas
    const busquedaNormalizada = removeAccents(busqueda.toLowerCase());

    return participantes.filter((participante) => {
      // Normaliza los nombres y apellidos de cada participante y los compara con la búsqueda
      const nombreNormalizado = removeAccents(participante.nombres.toLowerCase());
      const apellidoNormalizado = removeAccents(participante.apellidos.toLowerCase());

      return nombreNormalizado.includes(busquedaNormalizada) || apellidoNormalizado.includes(busquedaNormalizada);
    });
  };

  // * Función para obtener los participantes de la página actual con el filtro de búsqueda
  const obtenerParticipantesPorPagina = (participantes, page, cardsPorPagina, busqueda) => {
    // Filtramos los participantes según la búsqueda
    const participantesFiltrados = filtrarParticipantes(participantes, busqueda);

    // Calculamos los índices de la página actual
    const startIndex = (page - 1) * cardsPorPagina;
    const endIndex = startIndex + cardsPorPagina;

    // * CANTIDAD DE PARTICIPANTES.
    setCountParticipantesFilter(Math.ceil(participantesFiltrados.length / cardsPorPagina));

    // Devolvemos los participantes correspondientes a la página actual
    return participantesFiltrados.slice(startIndex, endIndex);
  };

  // * CAMBIAR PAGINA
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // * CODIGO PARA VALIDAR SI EL PARTICIPANTE DE UNA ENCUESTA PUEDE VOTAR EN LA MISMA
  // const [esParticipante,setEsParticipante] = useState(false);

  // useEffect(() => {
  //   if (participantes?.some(p => p.empleadoId == usuario.Id)) {
  //     setEsParticipante(true);
  //     swal({
  //         title: `Usted es participante de esta encuesta, no le es posible votar.`,
  //         icon: "warning",
  //         button: 'Aceptar'
  //     })
  //   }
  // }, [])

  // * VALIDACION DE CANTIDAD DE VOTOS POR EL USUARIO ACTIVO
  // * SI TIENE 3 VOTACIONES PUES NO PUEDE BOTAR.
  const validacionCantidadVotosUsuarios = participantes?.filter((x) => x.selectByUser).length === 3;

  // * BUSCAR ENCUESTAS.
  useEffect(() => {
    if (encuestas.length === 0) {
      dispatch(fetchBuscarEncuestas());
    }
  }, [encuesta]);

  useEffect(() => {
    if (criterios.length > 0 && openVotacionCriterios.open) {
      if (validacionCantidadVotosUsuarios) {
        swal('Advertencia', 'Has alcanzado el límite máximo de votos permitidos (3)', 'warning');

        // * LIMPIAR STATE.
        setOpenVotacionCriterios({ open: false, empleado: {} });
        return;
      }

      const arr = [];

      for (let i = 0; i < criterios.length; i++) {
        const { id, descripcion } = criterios[i];

        const newRegister = {
          criterioId: id,
          participanteId: openVotacionCriterios.empleado.participanteId,
          aplica: 0,
          descripcion,
        };

        arr.push(newRegister);
      }

      setValue('criteriosEmpleado', arr);
    }
  }, [criterios, openVotacionCriterios]);

  // * SWAL-ALERTAS.
  useEffect(() => {
    if (isSuccess === 'success' && message?.length > 0) {
      swal('Exitoso!', message, 'success');

      // * LIMPIAR
      dispatch(fetchBuscarEncuestas());
      dispatch(fetchCambiarSuccess());
      reset();
      setOpenVotacionCriterios({ open: false, empleado: {} });
      setPage(1);
      setParticipanteNombre('');
    } else if (isSuccess === 'error' && message?.length > 0) {
      swal('Error!', message, 'error');
      dispatch(fetchCambiarSuccess());
    }
  }, [isSuccess, message]);

  // * ACTUALIZAR FILTRADO.
  useEffect(() => {
    setParticipantesPagina(obtenerParticipantesPorPagina(participantes, page, cardsPorPagina, participanteNombre));
  }, [participanteNombre, participantes, page]);

  return (
    <Encabezado title={titulo}>
      <div className="card p-2">
        <div className="d-flex justify-content-end">
          <div className="col-5">
            <label className="fw-bold">Participante:</label>
            <input value={participanteNombre} className="form-control" onChange={(e) => setParticipanteNombre(e.target.value)} />
          </div>
        </div>
      </div>

      <Box mt={2}>
        <Grid container gap={2} justifyContent={'space-between'} paddingLeft={'30px'} paddingRight={'30px'}>
          {participantesPagina.map((participante) => (
            <Grid item xs={12} sm={'auto'} md={'auto'} key={participante.empleadoId} sx={{ display: 'flex' }}>
              <VotarCard
                participante={participante}
                usuario={usuario.Id}
                haVotado={haVotado || participante.selectByUser}
                usuarioVotado={usuarioVotado?.participanteId}
                criteriosHabilitado={criteriosHabilitado}
                setOpenVotacionCriterios={setOpenVotacionCriterios}
              />
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box display="flex" justifyContent="center" mt={2}>
        <Pagination count={countParticipantesFilter} page={page} onChange={handleChangePage} color="primary" />
      </Box>
      <Loading open={isLoading} />

      <FormProvider {...form}>
        <VotacionCriteriosCard open={openVotacionCriterios} setOpen={setOpenVotacionCriterios} />
      </FormProvider>
    </Encabezado>
  );
};
